import { render } from "./UserAlreadyExists.vue?vue&type=template&id=da0d5854"
import script from "./UserAlreadyExists.vue?vue&type=script&lang=ts"
export * from "./UserAlreadyExists.vue?vue&type=script&lang=ts"
script.render = render

export default script